/** @format */

import { Field, Formik, Form, useFormik } from "formik"
import React, { useEffect, useRef, useState } from "react"
import { Input } from "../../../../_metronic/_partials/controls"
import moment from "moment-jalaali"
import { Select } from "antd"
import DatePicker, { Calendar, utils } from "react-modern-calendar-datepicker"
import { useMediaQuery } from "react-responsive"
import { Button, Dialog, TextField } from "@material-ui/core"
import { getTownAndProvinces } from "../../Homepage/pages/widgets/components/cruds"
import * as Yup from "yup"
import isValidIranianNationalCode from "../../../../functions/nationalCodeValidation"
import Fieldz from "../../../../functions/Fieldz"
import { useDispatch, useSelector } from "react-redux"
import { actions } from "../redux"
import jalaali from "jalaali-js"
import { useHistory } from "react-router-dom"
import { isNull } from "lodash"

const persianREGEX = /^[\u0600-\u06FF]+$/
const iranianPostalCodeRegex = /\b(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}\b/gm

const validationSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, "نام حدقل ۲ کاراکتر باشد.")
    .required("پر کردن فیلد الزامی است"),

  // .typeError("فرمت وارد شده اشتباه است"),
  lastName: Yup.string()
    .min(1, "نام حدقل ۲ کاراکتر باشد.")
    .required("پر کردن فیلد الزامی است"),

  // .typeError("فرمت وارد شده اشتباه است"),
  fatherName: Yup.string("پر کردن فیلد الزامی است")
    .required("پر کردن فیلد الزامی است")

    .typeError("فرمت وارد شده اشتباه است"),
  // townshipId: Yup.string("فرمت وارد شده اشتباه است")
  //   .required("پر کردن فیلد الزامی است")
  //   .typeError("لطفا یکی از موارد داده شده را انتخاب کنید"),
  postalCode: Yup.string("فرمت وارد شده اشتباه است")
    .required("پر کردن فیلد الزامی است")
    .matches(iranianPostalCodeRegex, "کد پستی وارد شده نامعتبر است")
    .typeError("لطفا یکی از موارد داده شده را انتخاب کنید"),
  phone: Yup.string("فرمت وارد شده اشتباه است")
    .required("پر کردن فیلد الزامی است")
    .typeError("فرمت وارد شده اشتباه است"),
  address: Yup.string("فرمت وارد شده اشتباه است")
    .required("پر کردن فیلد الزامی است")
    .typeError("فرمت وارد شده اشتباه است"),
  // birthDate: Yup.string("فرمت وارد شده اشتباه است")
  //   .required("پر کردن فیلد الزامی است")
  //   .typeError("فرمت وارد شده اشتباه است"),
  nationalCode: Yup.string("فرمت وارد شده اشتباه است")
    .required("پر کردن فیلد الزامی است")
    .test(
      "nationalCode",
      "کد ملی وارد شده معتبر نیست",
      isValidIranianNationalCode
    )
    .typeError("فرمت وارد شده اشتباه است"),
  idNumber: Yup.string("فرمت وارد شده اشتباه است")
    .required("پر کردن فیلد الزامی است")

    .typeError("فرمت وارد شده اشتباه است"),
})

export default (props) => {
  console.log("test rendering")
  const ownerState = useSelector((state) => state.owner)
  console.log("ownerState in secend page", ownerState)
  const def = ownerState.ownerInfo.owner
  const nextDef = ownerState.ownerInfo.car
  console.log("def in secend page", def)
  const jalaliData = ownerState.ownerInfo.owner.birthDate
  console.log("ownerState", ownerState)
  const [selectedDay, setSelectedDay] = useState(null)
  const [towns, setTowns] = useState(null)
  const [city, setCity] = useState(null)
  const [initialValues, setInitialValues] = useState({})
  const [firstname, setFirstname] = useState("")
  const [lastname, setLasttname] = useState("")
  const [nationalcode, setNationalcode] = useState("")
  const [phone, setPhone] = useState("")
  const [errMessage, setErrMessage] = useState(null)

  const { OptGroup, Option } = Select
  // if(def.townshipId!=""){

  // }
  const TextFieldStyle = {
    width: "100%",
    // borderRadius: "13px",
    // border: "1px solid #d9d9d9",
    // width: isMobile ? "22rem" : "35rem",
    marginTop: "3.5rem",
  }

  const handleCity = (e) => {
    setCity(e)
  }

  const history = useHistory()

  const renderCustomInput = ({ ref }) => (
    <input
      readOnly
      ref={ref} // necessary
      placeholder="تاریخ تولد"
      value={
        selectedDay
          ? `${selectedDay.year}/${selectedDay.month}/${selectedDay.day}`
          : ""
      }
      style={{
        color: "gray",

        paddingRight: "10px",
        border: "1px solid #e4e6ef",
        height: "49px",
        borderRadius: "14px",
        width: "100%",

        // boxShadow: "0 1.5rem 2rem rgba(156, 136, 255, 0.2)",

        outline: "blue 1px",
      }}
      className="my-custom-input-class" // a styling class
    />
  )

  useEffect(() => {
    getTownAndProvinces().then((res) => {
      setTowns(res.data.data)
    })
  }, [])

  console.log("towns=====towns", towns)
  // const state = useSelector((state) => state.auth)
  // console.log("state", state)

  // useEffect(() => {
  //   if (state.user !== undefined) {
  //     const {
  //       firstName,
  //       lastName,
  //       fatherName,
  //       nationalCode,
  //       idNumber,
  //       birthDate,
  //       townshipId,
  //       postalCode,
  //       phone,
  //       address,
  //     } = state.user.user
  //     // setInitialValues(state.user.user);
  //     setInitialValues({
  //       firstName: firstName,
  //       lastName,
  //       fatherName,
  //       nationalCode,
  //       idNumber,
  //       birthDate,
  //       townshipId,
  //       postalCode,
  //       phone,
  //       address,
  //     })
  //     // setFirstname(firstName);
  //     // setLasttname(lastName);
  //     // setNationalcode(nationalCode);
  //     // setPhone(phone);
  //   }
  // }, [state.isAuthorized])

  const departuredDateRef = useRef(null)

  const dispatch = useDispatch()

  console.log("init", initialValues)
  console.log("props.stepEdit.edit", props.stepEdit.edit)

  return (
    <div className="p-5">
      <Formik
        enableReinitialize
        validationSchema={props.stepEdit.edit ? null : validationSchema}
        initialValues={{
          firstName: def.firstName,
          lastName: def.lastName,
          fatherName: def.fatherName,
          nationalCode: def.nationalCode,
          idNumber: def.idNumber,
          postalCode: def.postalCode,
          address: def.address,
          townshipId: def.townshipId,
          birthDate: def.birthDate,
          phone: def.phone,
        }}
        onSubmit={(values) => {
          console.log("testvalidation=========", values)
          if (props.stepEdit.edit) {
            console.log("test def", def)
            console.log("test values", values)
            const newValue = {
              // owner: { phone: ownerState?.ownerInfo.phone, ...values },
              owner: { ...def, ...values },

              car: {
                brandId: nextDef.brandId,
                carCode: nextDef.carCode,
                chassicNumber: nextDef.chassicNumber,
                color: nextDef.color,
                companyName: nextDef.companyName,
                engineNumber: nextDef.engineNumber,
                insuranceDate: nextDef.insuranceDate,
                insuranceNumber: nextDef.insuranceNumber,
                model: nextDef.model,
                ownerStats: nextDef.ownerStats,
                plateNumber: nextDef.plateNumber,
                plateSeries: nextDef.plateSeries,
                seatNumber: nextDef.seatNumber,

                smartCardNumber: nextDef.smartCardNumber,
                tip: nextDef.tip,
                vin: nextDef.vin,
              },
            }
            console.log("test new", newValue)
            dispatch(actions.getAllOwnerInfo(newValue))
            console.log("first page value", newValue)
            // console.log("ownerState", ownerState.ownerInfo);
            props.handleComplete()
          } else {
            const miladi = moment(
              `${selectedDay.year} /${selectedDay.month} / ${selectedDay.day}`,
              "jYYYY/jM/jD"
            ).format("YYYY-MM-DD")

            values.birthDate = miladi
            values.townshipId = city
            const newValue = {
              // owner: { phone: ownerState?.ownerInfo.phone, ...values },
              owner: { ...values },
              car: {
                brandId: "",
                carCode: "",
                chassicNumber: "",
                color: "",
                companyName: "",
                engineNumber: "",
                insuranceDate: "",
                insuranceNumber: "",
                model: "",
                ownerStats: "",
                plateNumber: "",
                plateSeries: "",
                seatNumber: "",
                seatNumber: "",
                smartCardNumber: "",
                tip: "",
                vin: "",
              },
            }
            dispatch(actions.getAllOwnerInfo(newValue))
            console.log("first page value", newValue)
            // console.log("ownerState", ownerState.ownerInfo);
            props.handleComplete()
          }
          setErrMessage(null)
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => {
          return (
            <>
              <h4 style={{ marginBlock: "3rem 1rem" }}>
                <b>مشخصات مالک</b>
              </h4>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.firstName}
                    name="firstName"
                    component={Input}
                    placeholder="نام (فارسی)"
                  />
                  {errors.firstName && touched.firstName ? (
                    <b className="text-danger mt-1">{errors.firstName}</b>
                  ) : null}
                </div>
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.lastName}
                    name="lastName"
                    component={Input}
                    placeholder="نام خانوادگی (فارسی)"
                  />
                  {touched.lastName && errors.lastName ? (
                    <b className="text-danger mt-1">{errors.lastName}</b>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.fatherName}
                    name="fatherName"
                    component={Input}
                    placeholder="نام پدر(فارسی) "
                  />
                  {errors.fatherName && touched.fatherName ? (
                    <b className="text-danger mt-1">{errors.fatherName}</b>
                  ) : null}
                </div>
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.nationalCode}
                    name="nationalCode"
                    component={Input}
                    placeholder="کدملی"
                  />
                  {touched.nationalCode && errors.nationalCode ? (
                    <b className="text-danger mt-1">{errors.nationalCode}</b>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.idNumber}
                    name="idNumber"
                    component={Input}
                    placeholder="شماره شناسنامه"
                  />
                  {errors.idNumber && touched.idNumber ? (
                    <b className="text-danger mt-1">{errors.idNumber}</b>
                  ) : null}
                </div>
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.nationalCode}
                    name="postalCode"
                    component={Input}
                    placeholder="کد پستی"
                  />
                  {touched.postalCode && errors.postalCode ? (
                    <b className="text-danger mt-1">{errors.postalCode}</b>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Select
                    placeholder="شهر محل سکونت"
                    name="townshipId"
                    defaultValue={def.townshipId}
                    style={{
                      width: "100%",

                      height: "49px",
                      borderRadius: "14px",
                    }}
                    onChange={(e) => handleCity(e)}
                  >
                    {towns
                      ? towns.map((data) => (
                          <OptGroup key={data.id} label={data.title}>
                            {data.Townships.map((res) => (
                              <Option key={res.code}>{res.title}</Option>
                            ))}
                          </OptGroup>
                        ))
                      : []}
                    {/* <Option value="jack">Jack</Option> */}

                    <Option value="Yiminghe">yiminghe</Option>
                  </Select>
                </div>
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.address}
                    name="address"
                    component={Input}
                    placeholder="آدرس"
                  />
                  {touched.address && errors.address ? (
                    <b className="text-danger mt-1">{errors.address}</b>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <Field
                    defaultValue={def.phone}
                    name="phone"
                    component={Input}
                    placeholder="شماره تلفن"
                  />
                  {errors.phone && touched.phone ? (
                    <b className="text-danger mt-1">{errors.phone}</b>
                  ) : null}
                </div>
                <div className="col-12 col-md-6 col-lg-6 mt-5">
                  <DatePicker
                    name="birthDate"
                    defaultValue="1400/3/21"
                    value={selectedDay}
                    onChange={setSelectedDay}
                    renderInput={renderCustomInput}
                    shouldHighlightWeekends
                    locale="fa" // add this
                  />
                </div>
              </div>

              <div
                className="d-flex align-items-center flex-wrap"
                style={{ marginBlock: "3rem 2rem" }}
              >
                <div className="col-12 col-md-6 my-3">
                  <Button
                    className="w-100"
                    style={{
                      height: "4rem",
                      backgroundColor: "#6dd06d",
                      borderRadius: "13px",
                    }}
                    onClick={() => {
                      handleSubmit()
                    }}
                  >
                    <h6 className="my-auto text-white">مرحله بعد</h6>
                  </Button>
                </div>
                <div className="col-12 col-md-6  my-3">
                  <Button
                    onClick={() => {
                      props.handleBack()
                    }}
                    className="w-100"
                    style={{
                      height: "4rem",
                      backgroundColor: "#d9d9d9",
                      borderRadius: "13px",
                    }}
                  >
                    <h6 className="my-auto text-white">بازگشت</h6>
                  </Button>
                </div>
              </div>
            </>
          )
        }}
      </Formik>
    </div>
  )
}
